<app-configuration-page
  title="Stripe"
  description="Connect your Stripe account to accept card payments and process refunds from within Agenda Master."
  [breadcrumbs]="[{ label: 'Integrations' }, { label: 'Stripe' }]">

  <app-form-stripe-settings></app-form-stripe-settings>

</app-configuration-page>
